/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 * Init translation for Pages titles
 *
 * @author Misha Kokoylin
 * @author Maxim Fedorov
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Julia Ignatieva
 * @author Evgeniy Naumov
 * @author Nikolay Sviridov
 * @version 1.32.0
 * @since 1.0.1
 */

import { ICommonTranslationPages } from '../../types/common/pages';

export const initTranslationPages: ICommonTranslationPages = {
    autoReport: '',
    autoReportId: '',
    account: '',
    accountInfo: '',
    bills: '',
    callsDetail: '',
    campaignInfo: '',
    campaigns: '',
    cashback: '',
    dashboard: '',
    expensesAnalyzer: '',
    historyOrder: '',
    inquiry: '',
    inquiryInfo: '',
    labelsImport: '',
    moneyTransfer: '',
    news: '',
    pageOrderId: '',
    pagePayments: '',
    personalAccount: '',
    productOfferings: '',
    products: '',
    reportsConstructor: '',
    reportsConstructorSubscribers: '',
    settings: '',
    subscriberFixed: '',
    subscriberId: '',
    subscriberMobile: '',
    wizardAdditionalAccounts: '',
    wizardAdditionalReports: '',
    wizardBillsDoc: '',
    wizardChangeLock: '',
    wizardExpensesDetail: '',
    wizardImportPersonalData: '',
    wizardMultiSearch: '',
    wizardOrderTemplateCreate: '',
    wizardOrderTemplateEdit: '',
    wizardOrderReport: '',
    wizardCollationReport: '',
    wizardImportSubscribersLimits: '',
    wizardChangeRole: '',
};
